import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';
import { connect } from 'react-redux';

import { translate } from '../commons/localize';
import { getAvailableHotelsList } from '../commons/apiCalls';
import { getHotelNameByCode } from '../commons/utils';

import withLoader from '../commons/withLoader';
import withModal from '../commons/hocModal';

import Header from '../commonComponents/Header';
import ConnectedMainContainer from './components/MainContainer';

import './reservationsTTOO.css';

export class ColoredScrollBars extends React.Component {
  constructor(props, ...rest) {
    super(props, ...rest);
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  handleUpdate(values) {
    const { top } = values;
    // eslint-disable-next-line react/no-unused-state
    this.setState({ top });
  }

  render() {
    return (
      <Scrollbars
        renderThumbVertical={({ style, ...props }) => <div style={{ ...style, backgroundColor: '#201E4B' }} {...props} />}
        onUpdate={this.handleUpdate}
        {...this.props}
      />
    );
  }
}

const ReservationsTTOO = (props) => {
  const [searchDone, setSearch] = useState(false);

  useEffect(() => {
    const { actualUser, getHotelsList, handleModalMessages } = props;

    getHotelsList(
      actualUser,
      (errorMessage) => {
        setSearch(true);
        handleModalMessages('errorModal', 'noExistenHoteles', errorMessage, 'entendido');
      },
      () => {
        setSearch(true);
      }
    );
    document.title = translate('reservasTTOO');
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const loginHotelName = getHotelNameByCode(props.defaultUserHotel, props.hotelsList);
  return (
    <ColoredScrollBars style={{ height: '100vh' }}>
      <div className="App">
        {searchDone && (
          <>
            <Header
              title={translate('reservasTTOO')}
              hotelName={loginHotelName}
              dirtyIndicator={false}
            />
            <ConnectedMainContainer />
          </>
        )}
      </div>
    </ColoredScrollBars>
  );
};

ReservationsTTOO.propTypes = {
  actualUser: PropTypes.string,
  defaultUserHotel: PropTypes.string,
  hotelsList: PropTypes.arrayOf(PropTypes.object),
  mainDirtyIndicator: PropTypes.bool,
  handleModalMessages: PropTypes.func,
  getHotelsList: PropTypes.func,
};

ReservationsTTOO.defaultProps = {
  actualUser: '',
  defaultUserHotel: '',
  hotelsList: [],
  mainDirtyIndicator: false,
  handleModalMessages: () => {},
  getHotelsList: () => {}
};

const mapStateToProps = state => ({
  actualUser: state.session.userCode,
  defaultUserHotel: state.session.userDefaultHotel,
  hotelsList: state.session.allHotelsList,
  isLoading: state.session.isLoading,
  mainDirtyIndicator: state.session.mainDirtyIndicator
});

const mapDispatchToProps = dispatch => ({
  getHotelsList: (userCode, errorCallback, requestCallBack) => {
    dispatch(getAvailableHotelsList(userCode, errorCallback, requestCallBack));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withLoader(withModal(ReservationsTTOO)));
export { ReservationsTTOO, mapStateToProps, mapDispatchToProps };
